export const DISCOUNT_AMOUNT_MIN_THRESHOLD = 0.01;
export const MONEY_AMOUNT_MIN_THRESHOLD = DISCOUNT_AMOUNT_MIN_THRESHOLD;
